// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { checkoutStepperStyles } from "@awc/App/Components/Checkout/CheckoutStepper";
import { CHECKOUT_BREAKPOINT } from "@awc/XDL/constants";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { hideElementOnPrint, xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

checkoutStepperStyles.step = {
    size: fontConfig.fontSize.regular,
    lineHeight: fontConfig.lineHeight.singleLineRegular,
    weight: fontConfig.weight.regular,
    css: css`
        &.current-step {
            font-weight: ${fontConfig.weight.bold};
        }
        ${xScreen("lte", CHECKOUT_BREAKPOINT)} {
            display: none;
            &.current-step {
                display: initial;
            }
        }
    `,
};

checkoutStepperStyles.wrapper = {
    css: css`
        display: flex;
        gap: 24px;
    `,
};
checkoutStepperStyles.operator = {
    css: css`
        line-height: ${fontConfig.lineHeight.singleLineRegular};
        ${xScreen("lte", CHECKOUT_BREAKPOINT)} {
            display: none;
        }
    `,
};
